var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnionPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    stroke: "#D8E1EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8788_23755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4507 14H33.6721C34.8197 14 35.5335 14.9071 35.2658 16.0236L31.4381 31.9593C31.168 33.072 30.019 33.9799 28.8705 33.9799H20.6499C19.5038 33.9799 18.7884 33.072 19.0562 31.9593L22.8854 16.0236C23.1532 14.9071 24.3016 14 25.4507 14Z",
    fill: "#E21836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9882 14H42.4427C43.5901 14 43.0727 14.9071 42.8028 16.0236L38.9757 31.9593C38.7072 33.072 38.791 33.9799 37.6411 33.9799H28.1866C27.0368 33.9799 26.3252 33.072 26.5953 31.9593L30.4222 16.0236C30.6939 14.9071 31.84 14 32.9882 14Z",
    fill: "#00447C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0674 14H50.2889C51.4381 14 52.1519 14.9071 51.882 16.0236L48.0549 31.9593C47.7848 33.072 46.6349 33.9799 45.4859 33.9799H37.2683C36.1184 33.9799 35.4052 33.072 35.6745 31.9593L39.5022 16.0236C39.7699 14.9071 40.9176 14 42.0674 14Z",
    fill: "#007B84"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8788_23755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 20,
    fill: "white",
    transform: "translate(19 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionPay);
export default __webpack_public_path__ + "static/media/UnionPay.d697b2be86727c82412434a0587c8ab7.svg";
export { ForwardRef as ReactComponent };